import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Media } from 'reactstrap';
import Avatar from '../common/Avatar';
import { Link } from 'react-router-dom';
import FeedDropDown from './FeedDropDown';
import SocialFalconCardHeader from '../common/SocialFalconCardHeader';
import { useSelector } from 'react-redux';
import { Or } from '../UI/preloading/PreloadState';
import moment from 'moment';

const FeedCardHeader = ({ id, title, author, created_at, status = true, dropPost }) => {
  const { condominium: { condominium }, auth: { user: { image, role } } } = useSelector(state => state);

  return (
    <SocialFalconCardHeader
      title={
        <Fragment>
          <Or cond={author === 'me'}>
            <Avatar value={true} src={`${image}`} size="2xl" />

            <Or value={false} cond={!!author.image} >
              <Or value={true}>
                <Avatar src={`${author.image}`} size="2xl" />
              </Or>
              <Or value={false}>
                <Avatar className={status} size="2xl" />
              </Or>
            </Or>
          </Or>
          <Media body className="align-self-center ml-2">
            <p className="text-left mb-1 line-height-1">
              <Link className="font-weight-semi-bold text-primary" to="#">
                {title}
              </Link>
            </p>
            <p className="text-left mb-0 fs--1">
              {moment(created_at).fromNow()} • {condominium} • <b>{author === 'me' ? 'Tú' : `${author.firstname} ${author.lastname}`}</b>
            </p>
          </Media>
        </Fragment>
      }
      titleTag={Media}
    >
      {role === 'manager' && <FeedDropDown id={id} dropPost={dropPost} />}
    </SocialFalconCardHeader>
  );
};

FeedCardHeader.propsType = {
  name: PropTypes.string.isRequired,
  time: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  status: PropTypes.string,
};

export default FeedCardHeader;